import { useReducedMotion } from "framer-motion";

export const siatEase = [0.22, 1, 0.36, 1];

export function useSiatMotion() {
  const reduce = useReducedMotion();
  return {
    reduce: !!reduce,
    fadeUp: reduce
      ? { hidden: { opacity: 1 }, show: { opacity: 1 } }
      : {
          hidden: { opacity: 0, y: 28 },
          show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.7, ease: siatEase },
          },
        },
    stagger: reduce
      ? { show: { transition: { staggerChildren: 0 } } }
      : {
          hidden: {},
          show: {
            transition: { staggerChildren: 0.1, delayChildren: 0.08 },
          },
        },
    scaleIn: reduce
      ? { hidden: { opacity: 1 }, show: { opacity: 1 } }
      : {
          hidden: { opacity: 0, scale: 0.94, y: 20 },
          show: {
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.75, ease: siatEase },
          },
        },
  };
}

export const viewportOnce = { once: true, amount: 0.22, margin: "0px 0px -8% 0px" };
